import type { AppTranslations } from 'translations/translations';
import type { ShowNotificationCommand } from 'utils/hooks/useNotifications';
import type { ApiRequestFunction } from 'utils/request/useApi';
import type { WebHookId } from '../WebHooksState';
import type { PrivateWebHooksCommands } from '../useWebHooks';

export interface DeleteDeliveriesHistoryCommand {
  id: WebHookId;
}

export const makeDeleteDeliveriesHistory =
  (
    apiRequest: ApiRequestFunction,
    msg: AppTranslations,
    showNotification: (command: ShowNotificationCommand) => void,
    getCommands: () => PrivateWebHooksCommands,
  ) =>
  async ({ id }: DeleteDeliveriesHistoryCommand): Promise<void> => {
    await apiRequest({
      url: `/webhooks/${id}/delivery`,
      method: 'DELETE',
    });

    const { loadRecentDeliveries } = getCommands();

    loadRecentDeliveries({ id });
    showNotification({
      type: 'success',
      message: msg.settings.webHooks.request.deletedHistory,
    });
  };
